import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const onlimetheme: BrandTheme = merge.all<BrandTheme, PartialBrandTheme>(
  brandTheme,
  {
    branding: {
      brand: 'ONLIME_WL',
      themedir: dirname(new URL(import.meta.url).pathname),
      staticDir: 'onlime',
      height: 40,
      learnMoreLinkWaitlist: 8061419,
      learnMoreLinkSearch: 8061492,
    },
    radii: [0, 15, 20, 30],
    fontSizes: resolveThemeUIFontSizes('onlime'),
    fonts: resolveFontFamily('onlime'),
    fontWeights: {
      light: 300,
      body: 400,
      heading: 500,
      bold: 500,
    },
    colors: {
      accent: '#99cc66',
      accentText: 'white',
      danger: 'rgba(237, 28, 36, 0.11)',
      dangerText: '#ED1C24',
      primary: '#73A604',
      secondary: '#e8e8e8',
      secondaryText: '#111',
      secondaryGreen: '#80BB4A',
      focus: '#464F36',
      focusDark: '#99cc66',
      text: '#464F36',
      textOpacity: 'rgba(69, 67, 76, 0.8)',
      activeBreadcrumb: '#73A604',
    },
    buttons: {
      primary: {
        borderColor: 'accent',
        backgroundColor: 'accent',
        color: 'accentText',
        borderRadius: '2em',
      },
      download: {
        border: '1px solid accent',
        backgroundColor: 'accent',
        borderRadius: '32px',
        px: '24px',
        textTransform: 'none',
        '&:not(:disabled):hover': {
          border: '1px solid accent',
        },
      },
      danger: {
        color: 'dangerText',
      },
    },
    cards: {
      photoUploadSuccess: {
        '--action-button-text-opacity': 1,
        bg: '#80bb4a',
      },
      photoUpload: {
        '--action-button-text-opacity': 1,
      },
    },
    styles: {
      h1: {
        letterSpacing: '0.03em',
      },
      fileIcon: {
        '--file-icon-border-color': '#8fc440',
        '--file-icon-symbol-color': '#8fc440',
      },
      downloadPageHeader: {
        color: 'black',
      },
      downloadSvg: {
        color: 'black',
      },
      subHeaderText: {
        fontWeight: 'body',
      },
      timelineHeading: {
        fontFamily: 'heading',
        fontSize: 4,
        fontWeight: 'heading',
      },
      addMoreSvg: {
        fontSize: 5,
      },
      newAlbumP: {
        fontFamily: 'heading',
        opacity: 0.8,
      },
      defaultProfilePicSvg: {
        color: 'secondaryGreen',
      },
    },
  },
)
export default onlimetheme
